module.exports = __webpack_public_path__ + "media/images/shop-f3a1b0779ca9d3cd2c218e57e4bcbe98.svg";